// extracted by mini-css-extract-plugin
module.exports = {"h5":"h5_h5__APwts"};